import { render } from "./grading-popup.vue?vue&type=template&id=605e829a&scoped=true"
import script from "./grading-popup.vue?vue&type=script&lang=js"
export * from "./grading-popup.vue?vue&type=script&lang=js"

import "./grading-popup.vue?vue&type=style&index=0&id=605e829a&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605e829a"]])

export default __exports__